"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = void 0;
const copyToClipboard = async (text) => {
    try {
        // Check if we are running in Electron and have access to the require function
        if (typeof window !== 'undefined' && window.require) {
            try {
                const electron = window.require('electron');
                if (electron && electron.clipboard) {
                    electron.clipboard.writeText(text);
                    return true;
                }
            }
            catch (e) {
                console.warn('Failed to copy using Electron clipboard API:', e);
            }
        }
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
        else {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            let success = false;
            try {
                success = document.execCommand('copy');
            }
            catch (e) {
                console.error('execCommand copy failed', e);
            }
            textArea.remove();
            return success;
        }
    }
    catch (err) {
        console.error('Clipboard copy failed', err);
        return false;
    }
};
exports.copyToClipboard = copyToClipboard;
